// Main Client Portal Application component

import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { logEnvironmentInfo } from './config/env';
import { clientTheme } from './theme';

/**
 * Main Client Portal Application component
 *
 * This component provides:
 * - Custom Chakra UI theme for the client portal
 * - Wrapper for all client portal routes (defined in routes.tsx)
 *
 * Note: This is wrapped by the main App.tsx which provides:
 * - QueryClientProvider for React Query
 * - AuthProvider for authentication (shared across both admin and client portals)
 * Routes are defined in /routes.tsx and rendered via Outlet
 */
export function ClientApp() {
  // Log environment info on mount
  useEffect(() => {
    logEnvironmentInfo();
  }, []);

  return (
    <ChakraProvider theme={clientTheme}>
      <Outlet />
    </ChakraProvider>
  );
}
